import React from 'react';
import { Zero } from './styles';

export const ZeroLoad: React.FC = () => {
  return <Zero></Zero>;
};
